module.exports = __webpack_public_path__ + "img/menu_btn.0e7947f1.png";